import { render, staticRenderFns } from "./UbicationView.vue?vue&type=template&id=4cb5179c&scoped=true"
import script from "./UbicationView.vue?vue&type=script&lang=js"
export * from "./UbicationView.vue?vue&type=script&lang=js"
import style0 from "./UbicationView.vue?vue&type=style&index=0&id=4cb5179c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb5179c",
  null
  
)

export default component.exports